import { render, staticRenderFns } from "./SignInOutMenuItem.vue?vue&type=template&id=8f3f638a&scoped=true"
import script from "./SignInOutMenuItem.vue?vue&type=script&lang=js"
export * from "./SignInOutMenuItem.vue?vue&type=script&lang=js"
import style0 from "./SignInOutMenuItem.vue?vue&type=style&index=0&id=8f3f638a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f3f638a",
  null
  
)

export default component.exports